import { AvailabilityItem } from "./availability-item";

export const AvailabilityList = ({ daysOfWeek }) => {
    return (
        <div>
            <ul role="list" className="space-y-4">
                {daysOfWeek.map((day) => (
                    <li
                        key={day}
                        role="listitem"
                        className="rounded-xl ring ring-gray-300"
                    >
                        <AvailabilityItem day={day} />
                    </li>
                ))}
            </ul>
        </div>
    );
};
